<template>
  <v-autocomplete
    :items="users"
    color="white"
    item-text="first_name"
    label="Current Responsibles"
    :filter="customFilter"
    clearable
    class="explorer-searchable-text mr-0"
  >
  </v-autocomplete>

</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import User from '@/api/User'

export default {
  name: 'UserSelectComponent',
  data() {
    return {      
      rules: {
        required: v => !!v || 'Field is mandatory'
      },      
    }
  },
  computed:{
    ...mapState([    
      'sitePath',
      'users'
    ]),
  },
  mounted: function() {
    this.GET_USERS(this.sitePath)
    console.log('UserSelectComponent', this.users)
    
  },
  methods: {
    ...mapActions(['GET_USERS']),    
    customFilter (user, queryText, itemText) {
      const textOne = user.first_name.toLowerCase()
      const textTwo = user.last_name.toLowerCase()
      const searchText = queryText.toLowerCase()

      console.log('textOne', textOne, 'textTwo', textTwo, 'searchText', searchText, 'itemText', itemText )

      return textOne.indexOf(searchText) > -1 ||
        textTwo.indexOf(searchText) > -1
    },
  },  
  
}
</script>
